import { Box, HStack, Image, Spinner, Text, VStack } from "native-base";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomButton from "../../../../components/button";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../../../utils/fonts";
import "./style.css";
import WebHeader from "../../../../layout/header/webHeader";
import { COLORS } from "../../../../utils/colors";
import Breadcrumbs from "../../../../components/breadcrumb";
import config from "../../../../utils/config";

const WebLandingPageBanner = ({
  openModal,
  show,
  bannerPath = [],
  isLoading = false,
}) => {
  const location = useLocation();
  const activeTab = useSelector((state) => {
    return state.event.activeTab;
  });
  const eventTab = activeTab === "event" ? "Event" : "MICE";
  const breadcrumbDetails = {
    activeTab: { name: "Home", path: "/home" },
    activeMenu: { name: `${eventTab} Detail`, path: "/event-detail" },
    activeActivePage: { name: "", path: "" },
  };

  function bannerText() {
    return (
      <VStack>
        <Text
          fontSize={"64px"}
          fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
          pt={2}
        >
          Welcome to ABG
        </Text>
        <Text fontSize={"64px"} fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}>
          MICE & Events
        </Text>
        <Text
          fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
          fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
        >
          This is a all in one platform where you can view all your events
        </Text>
        <Text
          fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
          fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
          pr={"12rem"}
          pt={2}
        >
          and MICE.
        </Text>
        <Text mt={4}></Text>
        {show && (
          <CustomButton
            onPress={() => {
              openModal();
            }}
            text="Raise Request"
            width="fit-content"
            py="10px"
          />
        )}
      </VStack>
    );
  }

  return (
    <Box bg={COLORS.WHITE_COLOR}>
      <Box pt={3} pb={1}>
        <WebHeader mt={0} />
      </Box>
      {location.pathname !== "/home" && (
        <Box pb={2} pt={4} px={"5rem"}>
          <Breadcrumbs path={breadcrumbDetails} />
        </Box>
      )}
      {isLoading ? (
        <Box
          mt={5}
          mb={10}
          flex={1}
          alignItems="center"
          justifyContent="center"
          minH={"550px"}
          height="600px"
        >
          <Spinner color={COLORS.THEME_COLOR} size="lg" />
        </Box>
      ) : bannerPath.length === 0 ? (
        <div className="landing-page-banner-container" p={"20px"}>
          <HStack flex={1} w="100%" h="100%">
            <Box w={"50%"} alignItems={"center"} justifyContent={"center"}>
              <Image
                source={{
                  uri: require("../../../../utils/quickLinkImages/home_banner.png"),
                }}
                alt="image"
                width="600px"
                height="600px"
              />
            </Box>
            <Box w={"50%"} pt="9rem" pr={"50px"} pb={"6rem"}>
              {bannerText()}
            </Box>
          </HStack>
        </div>
      ) : (
        <Box minH={"600px"} height={"600px"}>
          <Image
            source={{
              uri: config.bucketPath + bannerPath?.[0]?.file_name,
            }}
            alt="image"
            width="100%"
            height="100%"
            resizeMode="stretch"
          />
        </Box>
      )}
    </Box>
  );
};

export default WebLandingPageBanner;
